/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import Header from "./Header";
import Form from "./Form";
import Loader from "../../ui/Loader";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as appsActions from "../../../actions/appsActions";
import * as themesActions from "../../../actions/themesActions";
import * as experiencesActions from "../../../actions/experiencesActions";

class AppNavigationPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false,
		};
	}

	componentDidMount() {
		const { themesActions, experiencesActions, appsActions, match } = this.props;
		const { appKey } = match.params;
		themesActions.getThemes(appKey);
		experiencesActions.loadExperiences(appKey);
		appsActions.loadAppNavigation(appKey, this.navigationLoaded);
	}

	navigationLoaded = () => {
		this.setState({ loaded: true });
	};

	onSubmit = (values, submitHandler) => {
		const { appsActions, match } = this.props;
		const { appKey } = match.params;
		appsActions.editAppNavigation(appKey, values, submitHandler);
	};

	render() {
		const { themes, experiences, navigation } = this.props;
		const { loaded } = this.state;

		return (
			<Page>
				<div className="ta-center">
					<div className="sortable">
						<Header title="App Navigation" itemName="Navigation Item" />
						{navigation && loaded ? (
							<Form
								initialValues={navigation}
								onSubmit={this.onSubmit}
								themes={themes}
								experiences={experiences}
							/>
						) : (
							<Loader />
						)}
					</div>
				</div>
			</Page>
		);
	}
}

AppNavigationPage.propTypes = {
	match: PropTypes.object,
	experiences: PropTypes.array,
	themes: PropTypes.array,
	globalActions: PropTypes.object,
	appsActions: PropTypes.object,
	themesActions: PropTypes.object,
	experiencesActions: PropTypes.object,
	history: PropTypes.object,
	navigation: PropTypes.object,
};

const mapStateToProps = state => ({
	navigation: state.apps.navigation,
	experiences: state.experiences.experiences,
	themes: state.themes.themes,
});

const mapDispatchToProps = dispatch => ({
	globalActions: bindActionCreators(globalActions, dispatch),
	appsActions: bindActionCreators(appsActions, dispatch),
	themesActions: bindActionCreators(themesActions, dispatch),
	experiencesActions: bindActionCreators(experiencesActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AppNavigationPage);
